module.exports = __webpack_public_path__ + "static/media/1001682.a6a900ff.jpg";